// CIP Data Mapper - handles different database schemas
export const mapCipDataToStandardFormat = (rawData) => {
    if (!Array.isArray(rawData)) {
        return [];
    }

    return rawData.map(row => {
        // Handle different field naming conventions
        const mappedRow = {
            // ID fields - try both snake_case and camelCase
            cip_object_id: row.cip_object_id || row.cipObjectId,
            id: row.id,
            
            // Time fields
            step_start_time: row.step_start_time || row.stepStartTime,
            step_end_time: row.step_end_time || row.stepEndTime,
            cip_start_time: row.cip_start_time || row.cipStartTime,
            cip_end_time: row.cip_end_time || row.cipEndTime,
            
            // Waste fields - standardize to snake_case for frontend
            time_waste_s: row.time_waste_s || row.timeWasteS || 0,
            chemical_waste_l: row.chemical_waste_l || row.chemicalWasteL || 0,
            
            // Water waste - sum all water waste types for total
            water_waste_l: calculateTotalWaterWaste(row),
            
            // Alert types
            alert_types_csv: row.alert_types_csv || row.alertTypesCsv,
            
            // Other fields - map both naming conventions
            line: row.line,
            shift: row.shift,
            object_name: row.object_name || row.objectName,
            object_group_name: row.object_group_name || row.objectGroupName,
            recipe_name: row.recipe_name || row.recipeName,
            step_type: row.step_type || row.stepType,
            step_group_name: row.step_group_name || row.stepGroupName,
            water_type: row.water_type || row.waterType,
            impact_flags_json: row.impact_flags_json || row.impactFlagsJson,
            
            // Keep original row for debugging/reference
            _original: row
        };

        return mappedRow;
    });
};

// Helper function to calculate total water waste from all water waste fields
const calculateTotalWaterWaste = (row) => {
    let totalWaterWaste = 0;
    
    // Standard water waste
    totalWaterWaste += (row.water_waste_l || row.waterWasteL || 0);
    
    // Additional water waste types (if they exist)
    totalWaterWaste += (row.municipal_waste_l || row.municipalWasteL || 0);
    totalWaterWaste += (row.ro_waste_l || row.roWasteL || 0);
    
    // Add any other water waste fields that might exist
    // You can extend this based on what other businesses might have
    
    return totalWaterWaste;
};

// Optional: Helper to validate mapped data
export const validateCipData = (mappedData) => {
    const errors = [];
    
    mappedData.forEach((row, index) => {
        if (!row.cip_object_id) {
            errors.push(`Row ${index}: Missing cip_object_id`);
        }
        if (!row.step_start_time) {
            errors.push(`Row ${index}: Missing step_start_time`);
        }
        if (row.water_waste_l < 0 || row.time_waste_s < 0 || row.chemical_waste_l < 0) {
            errors.push(`Row ${index}: Negative waste values detected`);
        }
    });
    
    return errors;
};
